export class AsmPayload {
    userId: number;
    supportId: string;
    url: string;
    method: string;
    headers: any;
    body: string;
    readonly channel = 'ADMIN';

    constructor(props?: Partial<AsmPayload>) {
        Object.assign(this, props);
    }
}
